export const GET_SHIFTS_API = "/settings/shifts/";

export const ADD_SHIFT_API = "/settings/shifts/";

export const UPDATE_SHIFT_API = "/settings/shifts/";

export const DELETE_SHIFT_API = "/settings/shifts/";

export const GET_CLOSED_DAYS_API = "/settings/closed-days/";

export const ADD_CLOSED_DAY_API = "/settings/closed-days/";

export const UPDATE_CLOSED_DAY_API = "/settings/closed-days/";

export const DELETE_CLOSED_DAY_API = "/settings/closed-days/";

export const ADD_SPECIAL_OPENING_API = "/settings/shifts/special-opening/";


// WEBPACK FOOTER //
// ./src/apis/shifts.js